import { useState, useEffect, useRef } from "react";
import { X } from "lucide-react";
import { motion } from "framer-motion";
import "./NotificationSideBar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
} from '@fortawesome/free-solid-svg-icons';

import TooltipLocal from './TooltipLocal';

export default function NotificationSideBar() {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  // Close sidebar when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="notification-container">
      {/* Notification Icon */}
      <span onClick={() => setIsOpen(!isOpen)} className="notification-btn">
        <TooltipLocal text="Notification" position="left">
          <FontAwesomeIcon icon={faBell} size="2x" color="#3498db" />
        </TooltipLocal>
      </span>

      {/* Sidebar */}
      {isOpen && (
        <motion.div
          ref={sidebarRef}
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ duration: 0.3 }}
          className="notification-sidebar"
        >
          <button onClick={() => setIsOpen(false)} className="close-btn">
            <X className="icon" />
          </button>
          <h2 className="sidebar-title">Notifications</h2>
          <ul className="nav nav-pills p-0" role="tablist">
              <li className="nav-item">
                  <a className="nav-link active" data-bs-toggle="pill" href="#about">About</a>
              </li>
              <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="pill" href="#services">Services</a>
              </li>
              <li className="nav-item">
                  <a className="nav-link" data-bs-toggle="pill" href="#features">Features</a>
              </li>
          </ul>
          <div class="tab-content m-0">
              <div id="about" class="tab-pane active">
                <ul className="p-0">
                  <li className="p-0 m-1 card mb-2">
                    <div class="row m-0 mb-20 pt-3 pb-3">
                      <div class="col-auto">
                        <img class="img-40 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                      </div>
                      <div class="col">
                        <h6 class="m-0">Mukesh Kumar</h6>
                        <span class="m-0 f-12">Magento Developer</span>
                      </div>
                    </div>
                  </li>
                  <li className="p-0 m-1 card mb-2">
                    <div class="row m-0 mb-20 pt-3 pb-3">
                      <div class="col-auto">
                        <img class="img-40 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                      </div>
                      <div class="col">
                        <h6 class="m-0">Rohan Patil</h6>
                        <span class="m-0 f-12">Magento Developer</span>
                      </div>
                    </div>
                  </li>
                  <li className="p-0 m-1 card">
                    <div class="row m-0 mb-20 pt-3 pb-3">
                      <div class="col-auto">
                        <img class="img-40 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                      </div>
                      <div class="col">
                        <h6 class="m-0">Ravi Shankar</h6>
                        <span class="m-0 f-12">Magento Developer</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div id="services" class="tab-pane fade">
                <ul className="p-0">
                  <li className="p-0 m-1 card mb-2">
                    <div class="row m-0 mb-20 pt-3 pb-3">
                      <div class="col-auto">
                        <img class="img-40 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                      </div>
                      <div class="col">
                        <h6 class="m-0">Mukesh Kumar</h6>
                        <span class="m-0 f-12">Magento Developer</span>
                      </div>
                    </div>
                  </li>
                  <li className="p-0 m-1 card mb-2">
                    <div class="row m-0 mb-20 pt-3 pb-3">
                      <div class="col-auto">
                        <img class="img-40 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                      </div>
                      <div class="col">
                        <h6 class="m-0">Rohan Patil</h6>
                        <span class="m-0 f-12">Magento Developer</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div id="features" class="tab-pane fade">
                <ul className="p-0">
                  <li className="p-0 m-1 card mb-2">
                    <div class="row m-0 mb-20 pt-3 pb-3">
                      <div class="col-auto">
                        <img class="img-40 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                      </div>
                      <div class="col">
                        <h6 class="m-0">Mukesh Kumar</h6>
                        <span class="m-0 f-12">Magento Developer</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
          </div>
          
        </motion.div>
      )}
    </div>
  );
}
